import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
// import {
//   useArea,
//   useCategory,
//   useContractorPerson,
//   useEmployee,
// } from "app/_helpers/hooks";
// import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
// import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
// import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
// import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
// import { UserService } from "app/_services/UserService/UserService";
// // import { TRAINEE_TYPE, trainingStatusFilterFields } from "../../CONSTANTS";
// import { getContractor } from "app/_services/Contractor/ContractorService";
import { systemNotificationFilterFieldsEmail } from "../Constant";
import { CommmonService } from "app/_services/CommonService/CommonService";
// import { RoleService } from "app/_services/RoleService/RoleService";

export default function EmailFilter({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    sites: [],
  });
  const [typeData, setTypeData] = useState({
    typeArray: [],
  });

  //   const [contractors, setContractors] = useState([]);

  //   const [nameList, setNameList] = useState([]);
  const [roles, setRoles] = useState([]);

  // useEffect(() => {
  //   setNameList(
  //     form?.traineeTypeView === TRAINEE_TYPE.employee
  //       ? [...employeesOption]
  //       : form?.traineeTypeView === TRAINEE_TYPE.contractorPerson
  //       ? [...contractorPersonsOption]
  //       : [...employeesOption, ...contractorPersonsOption]
  //   );
  // }, [contractorPersonsOption, employeesOption, form?.traineeTypeView]);
  useEffect(() => {
    CommmonService.getAllEvents().then((response) => {
      if (!response?.data) return;

      setTypeData((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        typeArray: response?.data?.map((row) => ({ label: row.label, value: row.name })),
      }));
    });

    // getContractor().then((response) => {
    //   if (!response?.data) return;

    //   setContractors(response.data.map((d) => ({ label: d.contactPerson, value: d.id })));
    // });

    // RoleService.RoleList().then((response) => {
    //   if (!response?.data) return;

    //   setRoles(response?.data?.roles.map((d) => ({ label: d.title, value: d.id })));
    // });
  }, []);
  //   useEffect(() => {
  //     getAllSites("filter[status]=1").then((response) => {
  //       if (!response?.data) return;

  //       setState((prev) => ({
  //         ...prev,
  //         //initialActivity: response?.data,
  //         sites: response.data.map((row) => ({ label: row.name, value: row.id })),
  //       }));
  //     });

  //     getContractor().then((response) => {
  //       if (!response?.data) return;

  //       setContractors(response.data.map((d) => ({ label: d.contactPerson, value: d.id })));
  //     });
  //   }, []);
  const fields = useMemo(
    () =>
      systemNotificationFilterFieldsEmail.map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "siteId":
            field.options = state.sites;
            break;
          case "roleId":
            field.options = roles;
            break;
          case "eventType":
            field.options = typeData.typeArray;
            break;

          default:
            break;
        }

        return field;
      }),
    [typeData.typeArray]
  );
  console.log("this is email filter", form);

  const handleDateRange = (dates, name) => {
    console.log("dates", dates, name);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
        key: name,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
        key: name,
      },
    });
  };

  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        //  multiFieldDateRange
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
